/**
 * TODO - Add testimonies animations / physics thingie if we can
 */

document.addEventListener('DOMContentLoaded', function() {
    const testimoniesContainer = document.querySelector('.Testimonies_Container');

    if(testimoniesContainer === null) {
        return;
    }

    const TestimoniesColumns = document.querySelectorAll('.Testimonies_Container .Testimonies_Column');
    const testimonies = document.querySelectorAll('.Testimonies_Column .Testimony, .Testimonies_Column>div');

    let id = 0;
    const factor = 0.3;

    TestimoniesColumns.forEach(column => {
        const elems = column.querySelectorAll('.Testimonies_Column>div');
        // reverse elems order
        const reversedElems = Array.from(elems).reverse();

        // Add property delay
        reversedElems.forEach((elem) => {
            elem.style.setProperty('--delay', `${id * factor}s`);
            elem.style.setProperty('--angle', `${3 - Math.random() * 6}deg`);
            id++;
        });
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                testimonies.forEach(testimony => {
                    if(!testimony.classList.contains('Testimony_Shown')) {
                        testimony.classList.add('Testimony_Shown');
                    }
                });
            } else {

            }
        });
    }, {
        threshold: 0.1 // Adjust this value as needed
    });

    observer.observe(testimoniesContainer);

    class TestimonyAnimation {
        constructor(testimony) {
            this.testimony = testimony;
            this.lastY = null;
            this.angle = 0;
            this.padding = 10;
            this.angleFactor = 0.05;
            this.falloff = 0.01;
            this.maxAngle = 3;

            document.addEventListener('mousemove', this.onMouseMove.bind(this));
            requestAnimationFrame(this.animationLoop.bind(this));
        }

        onMouseMove(event) {
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            const rect = this.testimony.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            if (this.isOverLapping(mouseX, mouseY, rect)) {
                if (this.lastY !== null) {
                    const direction = Math.sign(mouseY - this.lastY);

                    if (mouseX > centerX) {
                        this.angle += direction * this.angleFactor;
                    } else {
                        this.angle -= direction * this.angleFactor;
                    }

                    // Limit angle
                    this.angle = Math.min(this.maxAngle, Math.max(-this.maxAngle, this.angle));
                }
            }
            this.lastY = mouseY;
        }

        isOverLapping(mouseX, mouseY, rect) {
            return mouseX > rect.left - this.padding && mouseX < rect.right + this.padding && mouseY > rect.top - this.padding && mouseY < rect.bottom + this.padding;
        }

        animationLoop() {
            this.angle = this.angle + (0 - this.angle) * this.falloff;
            this.testimony.style.setProperty('--angle', `${this.angle}deg`);
            requestAnimationFrame(this.animationLoop.bind(this));
        }
    }

    testimonies.forEach(testimony => {
        new TestimonyAnimation(testimony);
    });

    
});